import { Container, Row, Col, Card } from "react-bootstrap";

const AboutUs = () => {
  return (
    <section id="about" className="py-5 bg-light">
      <Container>
        <Row className="mb-5">
          <Col md={12} className="text-center">
            <h2 className="fw-bold">About Us</h2>
          </Col>
        </Row>
        <Row className="g-4">
          <Col md={6}>
            <Card className="h-100 p-4 border-0 shadow-sm">
              <h4 className="text-primary">Our Vision</h4>
              <p>
                To become a leading global provider of transformative education
                services that empower learners with knowledge, skills and values
                to thrive in an ever-changing world.
              </p>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="h-100 p-4 border-0 shadow-sm">
              <h4 className="text-primary">Our Mission</h4>
              <ul className="small">
                <li>
                  High-quality academic programs meeting international
                  standards.
                </li>
                <li>
                  Inspire critical thinking, effective communication, and
                  lifelong learning.
                </li>
                <li>
                  Build pathways for local/international study and career
                  growth.
                </li>
                <li>Integrate modern technology and global best practices.</li>
                <li>
                  Contribute to society by making education accessible and
                  ethical.
                </li>
              </ul>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default AboutUs;
